'use client'

import Link from 'next/link'
import Navbar from '@/components/Navbar'

/**
 * 404 body. Kept in its own client component so the parent
 * `app/not-found.tsx` can stay a server component and export the
 * `metadata` block (title + `robots: noindex`).
 */
export default function NotFoundContent() {
  return (
    <main className="bg-charcoal-900 min-h-screen flex flex-col">
      <Navbar forceDark />

      <div className="flex-1 flex items-center justify-center px-6">
        <div className="text-center">
          <p
            className="text-[clamp(6rem,20vw,12rem)] font-semibold leading-none text-white/[0.04] select-none"
          >
            404
          </p>
          <h1
            className="text-2xl md:text-3xl font-semibold text-white -mt-8 md:-mt-12 mb-4"
          >
            Page not found
          </h1>
          <p
            className="text-base text-white/40 max-w-md mx-auto mb-10 leading-relaxed"
          >
            The page you&apos;re looking for doesn&apos;t exist or has been moved.
          </p>
          <div
            className="flex flex-wrap items-center justify-center gap-3"
          >
            <Link
              href="/"
              className="after:hidden inline-flex items-center px-7 py-3.5 rounded-[10px] bg-white text-charcoal-900 font-display font-medium uppercase tracking-wider text-sm hover:bg-white/90 transition-colors duration-300"
            >
              Back to home
            </Link>
            <Link
              href="/work"
              className="after:hidden inline-flex items-center px-7 py-3.5 rounded-[10px] border border-white/15 text-white/70 font-display font-medium uppercase tracking-wider text-sm hover:border-white/30 hover:text-white transition-colors duration-300"
            >
              See our work
            </Link>
            <Link
              href="/blog"
              className="after:hidden inline-flex items-center px-7 py-3.5 rounded-[10px] border border-white/15 text-white/70 font-display font-medium uppercase tracking-wider text-sm hover:border-white/30 hover:text-white transition-colors duration-300"
            >
              Read the blog
            </Link>
          </div>
        </div>
      </div>
    </main>
  )
}
